const $win = $(window);
let winLastScrollTop = 0;
let stickyOffset = 90; // offset before firing the sticky header
let offsetAnnouncement = 51;
let offsetSecondNav = 23;

if( localStorage.seenAnnouncement == null || localStorage.seenAnnouncement != $( '.announcement-bar__content' ).text().trim() ) {
  stickyOffset = stickyOffset + offsetAnnouncement;
}

if ( $('.js-header-nav-secondary ul').length ) {
  stickyOffset = stickyOffset + offsetSecondNav;
}

/**
 * [stickyHeader description]
 * @param  {[type]} $header    [description]
 * @param  {[type]} fixedClass [description]
 * @return {[type]}            [description]
 */
function stickyHeader($header, fixedClass) {
  $win.on('scroll', function () {
    const scrollTop = $win.scrollTop();

    if (!$header.hasClass('is-fixed')) {
      if (scrollTop > stickyOffset) {
        $header.addClass(fixedClass);
      } else if (!$('.js-wrapper').hasClass('has-open-popup') && scrollTop <= stickyOffset){
        $header.removeClass(fixedClass);
      }
    }
  });
}

/**
 * Detect scroll direction
 * @param  {Function} cb - Callback function to execute
 * @return {Void}
 */

const scrollDirection = (cb) => {
  const scrollTop = $win.scrollTop();
  const isScrolledDown = scrollTop > winLastScrollTop;

  if (typeof cb === 'function') {
    cb(isScrolledDown);
  }

  winLastScrollTop = scrollTop <= stickyOffset ? stickyOffset : scrollTop;
};

$win.on('scroll load', function () {
  scrollDirection(function (isScrolledDown) {
    $('.nav-secondary').toggleClass('is-hidden', isScrolledDown);
  });
});

module.exports = {
  stickyHeader,
};
